import _ from 'lodash';
import { FETCH_SHOWS, FETCH_MOVIES } from './HoverMenuActions';

const INITIAL_STATE = {
  shows: null,
  movies: null,
};

export default function(state = INITIAL_STATE, action) {
  const data = _.get(action, 'payload.data', null);
  switch (action.type) {
    case FETCH_MOVIES: {
      const movies = _.get(data, 'panels.member[0].customViews', null);
      return {
        ...state,
        movies,
      };
    }
    case FETCH_SHOWS: {
      const showsResponse = _.get(data, 'panels.member');
      let shows = null;
      showsResponse.forEach(item => {
        if (item.headline === 'All Shows') {
          shows = item.customViews;
        }
      });
      return {
        ...state,
        shows,
      };
    }
    default:
      return state;
  }
}
